<template>
    <multiselect
        class="shop__menu-bar__sort shop__multiselect"
        v-model="value"
        openDirection="below"
        :searchable="false"
        :show-labels="false"
        :options="options"
        track-by="name"
        label="name"
        :allow-empty="false"
        />
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'SortDropdown',
    components: { Multiselect },
    computed: {
        value: {
            get() {
                return this.$store.getters['shop/getSortMethod'];
            },
            set(value) {
                this.$store.commit('shop/setSortMethod', value);
            },
        },
        options() {
            const sortOptions = [
                { name: this.$t('MOST_POPULAR'), key: 'default' },
                { name: this.$t('LOW_TO_HIGH'), key: 'low-high' },
                { name: this.$t('HIGH_TO_LOW'), key: 'high-low' },
            ];
            return sortOptions;
        },
    },
};
</script>
